import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'

import makeData from './makeData'
import {FormattedMessage} from "react-intl";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data ,deleteUser,username, selectItem, userRole}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  const roles = ((userRole) ? userRole.split(",") : [])
  // Render the UI for your table
  return (
    <div 
    className="tablewrapper" 
    style={
        (!roles || (roles.includes('TRANSLATION_LEAD') || roles.includes('DATA_ENGINEER')))
        ? {}
        : { height: 'calc(100vh - 280px)' }
    }>
      <table {...getTableProps()} >
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()} >
          <th style={{textAlign:'center'}}>Select</th>
          {headerGroup.headers.map(column => (
            <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>{column.render('Header')}</th>
          ))}
        </tr>
      ))}
      </thead>
      <tbody {...getTableBodyProps()}>
      {rows.map((row, i) => {
        prepareRow(row)
        // if(row.values.status != "DELETED" && row.values.username !== username){
       // if(row.values.username !== username){
          return (
            <tr {...row.getRowProps()}>
              <td>
                <input style={{width: '15px', marginLeft:'15px'}} type="radio" name="radio1" value={data[i]} onChange={()=>{selectItem(data[i]);}}
                />
              </td>
              {row.cells.map(cell => {
                if(cell.value !== "null"){
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                }else{
                  return <td {...cell.getCellProps()}></td>
                }
              })}
            </tr>
          )
      //  }
      })}
      </tbody>
    </table>
    </div>
  )
}

function App(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Data Factory Name',
        accessor: 'reponame', // accessor is the "key" in the data
      },
      {
        Header: 'Type',
        accessor: 'type', // accessor is the "key" in the data
      },
      {
        Header: 'Platform Version',
        accessor:'sparkversion' //'firstName',
      },
      {
        Header: 'Target Language',
        accessor: 'tgtlang'   //'lastName', // accessor is the "key" in the data
      },
      // {
      //   Header: 'Hive/Hadoop Version',
      //   accessor: 'hive', // accessor is the "key" in the data
      // },

      {
        Header: '# of SQL/NoSQL Data Sources',
        accessor: 'numofjdbc', // accessor is the "key" in the data
      },

      {
        Header: 'Owner',
        accessor: 'owner', // accessor is the "key" in the data
      },

       {
          Header: 'Last Updated Time',
          accessor: 'updateTime', // accessor is the "key" in the data
        },
        {
          Header: 'Updated By',
          //accessor:'name',
          accessor: 'updateBy', // accessor is the "key" in the data
        }
    ],
    []
  );

  // const data2 = React.useMemo(() => makeData(20), [])

  return (
    <Styles>
      <Table columns={columns} data={props.data} selectItem={props.selectItem} deleteUser={props.deleteUser} username={props.username} userRole={props.userRole}/>
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/Datafactorymanagement/table.js